import React from 'react';
import PropTypes from 'prop-types';
import { formatShortDate } from './salesTargetsPeriodUtils';

const formatDate = (value) => {
  if (!value) return '—';
  return formatShortDate(value) || '—';
};

/**
 * Compact period-weeks table: Week | Start | End
 */
const PeriodWeeksTable = ({ weeks, title, emptyMessage }) => {
  const rows = Array.isArray(weeks) ? weeks : [];

  return (
    <div className="sales-targets-period-weeks">
      {title ? <div className="sales-targets-period-weeks-title">{title}</div> : null}
      {rows.length > 0 ? (
        <table className="sales-targets-period-weeks-table">
          <thead>
            <tr>
              <th>Week</th>
              <th>Start</th>
              <th>End</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((week, index) => (
              <tr key={`${week.week_start}-${week.week_end}-${index}`}>
                <td className="sales-targets-period-weeks-week">W{index + 1}</td>
                <td>{formatDate(week.week_start)}</td>
                <td>{formatDate(week.week_end)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <p className="sales-targets-weekly-hint">{emptyMessage}</p>
      )}
    </div>
  );
};

PeriodWeeksTable.propTypes = {
  weeks: PropTypes.arrayOf(
    PropTypes.shape({
      week_start: PropTypes.string,
      week_end: PropTypes.string,
    })
  ),
  title: PropTypes.node,
  emptyMessage: PropTypes.string,
};

PeriodWeeksTable.defaultProps = {
  weeks: [],
  title: 'Period weeks',
  emptyMessage: 'No weeks defined for the current period.',
};

export default PeriodWeeksTable;
